import { ContentCopy, CopyAll, Edit, EditOff } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { MarkdownTextEditor } from 'ui/MarkdownTextEditor';
import { MarkdownToHtmlConverter } from 'ui/MarkdownToHtmlConverter';
import { COLORS } from 'services/constants/colors';
import { TEditedTextParameterProps } from './types';

export const EditedTextParameter: FC<TEditedTextParameterProps> = ({ name, value, onChange }) => {
	const [openEditor, setOpenEditor] = useState(false);
	const handleEditClick = () => {
		setOpenEditor(!openEditor);
	};

	const [copy, setCopy] = useState(false);
	const copyToClipboard = () => {
		navigator.clipboard
			.writeText(value)
			.then(() => {
				console.log('copied');
				setCopy(true);
				setTimeout(() => {
					setCopy(false);
				}, 2000);
			})
			.catch(err => {
				console.log('Something went wrong', err);
			});
	};

	return (
		<Box
			sx={{
				border: `1px solid ${COLORS.BORDER}`,
				borderRadius: '12px',
				padding: '5px 10px',
				width: 'calc(100% - 20px)',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
				}}
			>
				<Typography
					sx={{
						fontSize: '.8rem',
					}}
					color="primary"
				>
					{name}
				</Typography>
				<Box>
					{value && (
						<IconButton
							size="small"
							color="primary"
							onClick={e => {
								e.preventDefault();
								e.stopPropagation();
								copyToClipboard();
							}}
						>
							<ContentCopy fontSize="small" />
						</IconButton>
					)}
					<IconButton color="primary" onClick={handleEditClick} size="small">
						{openEditor ? <EditOff fontSize="small" /> : <Edit fontSize="small" />}
					</IconButton>
				</Box>
			</Box>
			<Box
				sx={{
					// border: '1px solid #ccc',
					// borderRadius: '12px',
					// padding: '5px',
					width: 'auto',
				}}
			>
				<MarkdownToHtmlConverter markdownText={value} />
				{openEditor && <MarkdownTextEditor text={value} setText={val => onChange(val)} />}
			</Box>
		</Box>
	);
};
